import React from 'react';
import superagent from 'superagent';
import {Modal, Button} from 'react-bootstrap';

import InfoMsg  from '../../api/InfoMsg';
import KalendarModalInfo from './KalendarModalInfo'

import { LoggedUserId } from '../login/Login';

import styles from './Home.css';

function AddZero(value) {
  return ("0" + value).slice(-2);
}

function GetNyni(d) {
  return d.getFullYear() + '-' + AddZero(d.getMonth()+1) + '-' + AddZero(d.getDate()) + ' ' + AddZero(d.getHours()) + ':' + AddZero(d.getMinutes());
}

function LekceTD(prop) {
  var nyni = GetNyni(new Date());
  var lekceEl = prop.lekce.map((lekce) => {
    var zacatek = lekce.date + ' ' + lekce.cas_od;

    if (lekce.aktivni == 'N') {
      var barva = 'table-secondary';
    } else if (nyni > zacatek) {
      var barva = 'table-secondary';
    } else if (lekce.prihlasen == 'A') {
      var barva = 'text-white bg-success';
    } else if (1*lekce.pocet >= 1*lekce.kapacita) {
      var barva = 'table-danger';
    } else {
      var barva = 'table-success';
    }
    return (
      <div key={lekce.id} className={barva + " text-center cursor m-1 rounded-lg"} >
        {(lekce.prihlasen_pocet > 0) ? <div className="lekce_pocet rounded-circle">{lekce.prihlasen_pocet}</div> : null}
        <div className="p-1" onClick={prop.setActLekce} data-id={lekce.id} >
          <strong className="d-none d-md-inline" onClick={prop.setActLekce} data-id={lekce.id} >{lekce.nazev}<br /></strong>
          <span className="d-none d-md-inline" >{lekce.cas_od} - {lekce.cas_do}<br /></span>
          {lekce.pocet}/{lekce.kapacita}
        </div>
      </div>
    )
  });

  return (
    <div className="kalendar_lekce">
      {lekceEl}
    </div>
  )
}

export default class Kalendar extends React.Component {

  constructor() {
    super();
    this.state = {
      errorMessage: '',
      errorMessageReg: '',
      styleMsg: '',
      datum: new Date(),
      lekce: null,
      actLekce: null,
      showModal: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleIncMonth = this.handleIncMonth.bind(this);
    this.handleDecMonth = this.handleDecMonth.bind(this);
    this.setActLekce = this.setActLekce.bind(this);
    this.loadLekce = this.loadLekce.bind(this);
    this.handleShowModalInfo = this.handleShowModalInfo.bind(this);
    this.handleCloseModalInfo = this.handleCloseModalInfo.bind(this);
  }

  componentWillMount = () => {
    this.loadLekce();
  }

  showModal() {
    $('#exampleModalCenter').modal('show')
  }

  setActLekce(e) {
    var lekce = this.getLekciProID(e.target.dataset.id);
    this.setState({actLekce: lekce, showModal: true}, this.showModal);
  }

  handleShowModalInfo() {
    this.setState({showModal: true});
  }

  handleCloseModalInfo() {
    this.setState({showModal: false});
  }

  loadLekce() {
    var obdobi = this.state.datum.getFullYear() + '-' + ("0" + (this.state.datum.getMonth() + 1)).slice(-2);
    var responseObj = superagent.get('https://rezervace.copasedeje.cz/servis/_lekce_list.php?userid=' + LoggedUserId() + '&obdobi=' + obdobi + '&t=' + Date()).set('Content-Type', 'application/json').then(response => {
      var myObject = JSON.parse(response.text);
      this.setState({lekce: myObject});
      if (myObject != null) {
        this.setState({actLekce: myObject[0]});
      }
    });
  }

  handleIncMonth() {
    var newDate = new Date(this.state.datum.getFullYear(), this.state.datum.getMonth()+1, 1)
    this.setState({datum: newDate, lekce: null}, this.loadLekce);
  }

  handleDecMonth() {
    var newDate = new Date(this.state.datum.getFullYear(), this.state.datum.getMonth()-1, 1);
    this.setState({datum: newDate, lekce: null}, this.loadLekce);
  }

  handleChange() {
    this.setState({errorMessage: '', styleMsg: ''});
  }

  getLekciProDen(den) {
    if (this.state.lekce != null) {
      for (var i = 0; i < this.state.lekce.length; i++) {
        if (this.state.lekce[i].den == den) {
          return this.state.lekce[i];
        }
      }
    }
    return null;
  }

  getLekceProDen(den) {
//console.log(this.state.lekce);
    var lekce = [];
    if (this.state.lekce != null) {
      for (var i = 0; i < this.state.lekce.length; i++) {
        if (this.state.lekce[i].den == den) {
           lekce.push(this.state.lekce[i]);
        }
      }
    }
//console.log(lekce);
    return lekce;
  }

  getLekciProID(id) {
    if (this.state.lekce != null) {
      for (var i = 0; i < this.state.lekce.length; i++) {
        if (this.state.lekce[i].id == id) {
          return this.state.lekce[i];
        }
      }
    }
    return null;
  }

  render() {
    var months = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
    var d = this.state.datum;
    var d1 = new Date(d.getFullYear(), d.getMonth(), 1);
    var startDay = d1.getDay();
    if (startDay == 0) { startDay = 7; }
    var days = [];
    for (var i = 1; i < startDay; i++) {
      days.push({den: '', pocet: 0, lekce: null});
    }
    var pocetDnu = new Date(d.getFullYear(), d.getMonth()+1, 0).getDate();
    for (var i = 1; i <= pocetDnu; i++) {
      days.push({den: i, pocet: 0, lekce: this.getLekceProDen(i)});
    }
    var finishDay = days.length%7;
    if (finishDay == 0) { finishDay = 7; }
    for (var i = finishDay; i < 7; i++) {
      days.push({den: '', pocet: 0, lekce: null});
    }
    var index = 0;
    var weeks = [];
    for (var i = 0; i < days.length/7; i++) {
      weeks.push([days[i*7], days[i*7+1], days[i*7+2], days[i*7+3], days[i*7+4], days[i*7+5], days[i*7+6]]);
    }

    var keyT = 0;
    var keyD = 0;
    var tydny = weeks.map((tyden) => {
      var dny = tyden.map((den) => {
        keyD++
        return (
          <td key={keyD} className="bg-white p-0">
            <div className="kalendar_den pl-2">{den.den}</div>
              {((den.lekce != null) && (den.lekce.length > 0)) ? <LekceTD lekce={den.lekce} pocet={den.pocet} setActLekce={this.setActLekce} /> : <div className="kalendar_lekce"></div>}
          </td>
        )
      });

      keyT++
      return (
        <tr key={keyT} className="">
          {dny}
        </tr>
      )
    });

    return (
      <div className={styles.root}>
        <h3 className="text-uppercase text-center m-3">
          <a onClick={this.handleDecMonth} className={"float-left " + styles.pointer}>&lt;</a>
          {months[d.getMonth()] + ' ' + d.getFullYear()}
          <a onClick={this.handleIncMonth} className={"float-right " + styles.pointer}>&gt;</a>
        </h3>
        <table id="kalendar_table" className="table table-bordered shadow">
          <tbody>
            <tr id="kalendar_table_header">
              <td className="text-center font-weight-bold">PO</td>
              <td className="text-center font-weight-bold">ÚT</td>
              <td className="text-center font-weight-bold">ST</td>
              <td className="text-center font-weight-bold">ČT</td>
              <td className="text-center font-weight-bold">PÁ</td>
              <td className="text-center font-weight-bold">SO</td>
              <td className="text-center font-weight-bold">NE</td>
            </tr>
            {tydny}
          </tbody>
        </table>
        <KalendarModalInfo lekce={this.state.actLekce} loadLekce={this.loadLekce} addKredit={this.props.addKredit} />
      </div>
    )
  }


}



// WEBPACK FOOTER //
// src/components/kalendar/Kalendar.js